import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Components
import Shell from '../Shell'
import ArticleList from '../ArticleList'
import CollectionIcon from '../CollectionIcon'
import CollectionNav from '../CollectionNav'

// Types
import type { FetchHelpCollectionResponse } from '@/api/fetchHelpCollection'
import type { HelpCollectionItem } from '@/api/fetchHelpArticle'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

type Props = {
  data: FetchHelpCollectionResponse
  /** 側欄用：站點全部第一層分類 */
  collections: HelpCollectionItem[]
  countryCode: string
  countryQuery?: string
}

const HelpCollection = ({ data, collections, countryCode, countryQuery }: Props) => {
  const { t } = useTranslation()
  const { collection, breadcrumbs, subcollections, articles } = data
  // 子分類頁時，側欄標示它的第一層分類
  const activeTopId = breadcrumbs[0]?.id ?? collection.id

  return (
    <Shell breadcrumbs={breadcrumbs} countryCode={countryCode} countryQuery={countryQuery}>
      <div className={cx('help-collection-layout')}>
        <aside className={cx('help-collection-layout__nav')}>
          <CollectionNav collections={collections} activeId={activeTopId} countryQuery={countryQuery} />
        </aside>

        <div className={cx('help-collection-layout__main')}>
          <header className={cx('help-collection-header')}>
            <span className={cx('help-collection-header__badge')}>
              <CollectionIcon src={collection.iconUrl} size={36} />
            </span>
            <div>
              <h1 className={cx('help-collection-header__name')}>{collection.name}</h1>
              {collection.description && <p className={cx('help-collection-header__desc')}>{collection.description}</p>}
              <p className={cx('help-collection-header__count')}>{t('Help_Center_Article_Count', { count: collection.articleCount })}</p>
            </div>
          </header>

          {(articles.length > 0 || subcollections.length === 0) && (
            <section className={cx('help-card')}>
              <ArticleList articles={articles} countryQuery={countryQuery} />
            </section>
          )}

          {subcollections.map((sub) => (
            <section key={sub.id} className={cx('help-card')}>
              <h2 className={cx('help-card__title')}>{sub.name}</h2>
              {sub.description && <p className={cx('help-card__desc')}>{sub.description}</p>}
              <ArticleList articles={sub.articles} countryQuery={countryQuery} />
            </section>
          ))}
        </div>
      </div>
    </Shell>
  )
}

export default HelpCollection
